import { useQuery } from '@apollo/react-hooks';
import { useContext, useEffect } from 'react';
import throwErrorInDev from '../../helpers/throwErrorInDev';
import { CartIdContext } from '../Cart/CartIdContext';
import debounce from 'lodash.debounce';
import { useTracker } from '../../analytics/Analytics';
import { trackCartEvent } from '../../analytics/tracking';
export function useCart(cartQuery) {
    const { cartId } = useContext(CartIdContext);
    const result = useQuery(cartQuery, {
        variables: { cartId },
        skip: __IN_SERVER__
    });
    const track = useTracker();
    useEffect(() => {
        var _a;
        track(trackCartEvent({
            cart: (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.cart
        }));
    }, [result, track]);
    return { result, cart: result.data && result.data.cart };
}
const useLocalStorageCart = (refetch) => {
    let debounceRefetch = null;
    useEffect(() => {
        const listener = (e) => {
            const localStorageCart = localStorage.getItem('cartChange');
            if (e.storageArea === localStorage &&
                e.key === 'cartChange' &&
                localStorageCart) {
                if (debounceRefetch)
                    debounceRefetch.cancel();
                debounceRefetch = debounce(() => {
                    refetch();
                }, 1500);
                debounceRefetch();
                localStorage.removeItem('cartChange');
            }
        };
        window.addEventListener('storage', listener);
        return () => {
            window.removeEventListener('storage', listener);
        };
    });
};
export default function CartProvider({ children, query }) {
    throwErrorInDev(!query, `You forgot to pass 'query' to CartProvider`);
    const { result } = useCart(query);
    useLocalStorageCart(result.refetch);
    return children(result);
}
//# sourceMappingURL=CartProvider.js.map